module.exports = "/static/Images/pt-br/Satisfied.png";